import { render } from "./appLayout.vue?vue&type=template&id=27c96c2c"
import script from "./appLayout.vue?vue&type=script&lang=js"
export * from "./appLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__